import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./button.html";
import { getBooleanAttr, getObjectAttr } from '../common/common';
export let SizeTypes = /*#__PURE__*/function (SizeTypes) {
  SizeTypes["UltraSmall"] = "ultrasmall";
  SizeTypes["Slim"] = "slim";
  SizeTypes["ExtraSmall"] = "extrasmall";
  SizeTypes["Small"] = "small";
  SizeTypes["Medium"] = "medium";
  SizeTypes["Default"] = "default";
  SizeTypes["Wide"] = "wide";
  SizeTypes["Hero"] = "hero";
  return SizeTypes;
}({});
export let VariantTypes = /*#__PURE__*/function (VariantTypes) {
  VariantTypes["Primary"] = "primary";
  VariantTypes["Secondary"] = "secondary";
  VariantTypes["Tertiary"] = "tertiary";
  return VariantTypes;
}({});
class AdsButton extends LightningElement {
  constructor(...args) {
    super(...args);
    this.callToAction = {};
    this._disabled = false;
    this._variant = VariantTypes.Primary;
    this._size = SizeTypes.Default;
    this.className = '';
    this.tabIndex = 0;
    this.slotsClasses = {};
  }
  handleSlotChange(event) {
    const slot = event.target;
    const nodes = slot.assignedNodes();
    if (nodes) {
      this.slotsClasses[slot.name] = nodes.length !== 0 ? slot.name : 'none';
    }
    if (!slot.name && nodes && nodes.length !== 0) {
      // If slot default has text will set in the label props of the CallToAction
      this.callToAction.label = nodes[0].textContent || undefined;
    }
  }
  set props(value) {
    const props = getObjectAttr(value);
    if (props) {
      if (props.callToAction) {
        this.callToAction = props.callToAction;
      }
      this._disabled = props.disabled;
      if (props.size) {
        this._size = props.size;
      }
      if (props.variant) {
        this._variant = props.variant;
      }
    }
  }
  get props() {
    return {
      disabled: this.disabled,
      callToAction: this.callToAction,
      size: this.size,
      variant: this.variant
    };
  }
  set variant(value) {
    this._variant = value;
  }
  get variant() {
    return this._variant;
  }
  set size(value) {
    this._size = value;
  }
  get size() {
    return this._size;
  }
  set disabled(value) {
    // In case it is set as "disable", it returns true
    this._disabled = getBooleanAttr(value, value === '');
  }
  get disabled() {
    return this._disabled;
  }
  set name(value) {
    this.callToAction.name = value;
  }
  get name() {
    var _this$callToAction$na;
    return (_this$callToAction$na = this.callToAction.name) !== null && _this$callToAction$na !== void 0 ? _this$callToAction$na : this.label;
  }
  set label(value) {
    this.callToAction.label = value;
  }
  get label() {
    var _this$callToAction$la;
    return (_this$callToAction$la = this.callToAction.label) !== null && _this$callToAction$la !== void 0 ? _this$callToAction$la : '';
  }
  get _className() {
    let className = this.className || '';
    className += ' button';
    if (this.size !== SizeTypes.Default) {
      className += ' button--' + this.size;
    }
    className += ' button--' + this.variant;
    return className;
  }
  handleAnalytics(event) {
    event.detail.button = this.props;
  }

  // Since slot can add the onclick we need to stop the event manually
  handleClick(event) {
    if (this.disabled) {
      event.stopPropagation();
    }
  }
  /*LWC compiler v7.1.3*/
}
AdsButton.delegatesFocus = true;
_registerDecorators(AdsButton, {
  publicProps: {
    className: {
      config: 0
    },
    tabIndex: {
      config: 0
    },
    props: {
      config: 3
    },
    variant: {
      config: 3
    },
    size: {
      config: 3
    },
    disabled: {
      config: 3
    },
    name: {
      config: 3
    },
    label: {
      config: 3
    }
  },
  track: {
    callToAction: 1,
    _disabled: 1,
    _variant: 1,
    _size: 1,
    slotsClasses: 1
  }
});
const __lwc_component_class_internal = _registerComponent(AdsButton, {
  tmpl: _tmpl,
  sel: "ads-button",
  apiVersion: 62
});
export default __lwc_component_class_internal;